import React from 'react';

export function TickerActions({ ticker, busy, onRefresh, onRemove }: {
  ticker: string; busy: boolean; onRefresh: () => void; onRemove: () => void;
}): JSX.Element {
  const container = React.useRef<HTMLDetailsElement>(null);
  React.useEffect(() => {
    const dismiss = (event: PointerEvent) => {
      if (container.current && !container.current.contains(event.target as Node)) container.current.open = false;
    };
    document.addEventListener('pointerdown', dismiss);
    return () => document.removeEventListener('pointerdown', dismiss);
  }, []);
  function action(callback: () => void) {
    if (container.current) container.current.open = false;
    container.current?.querySelector('summary')?.focus();
    callback();
  }
  return <details className="tc-ticker-actions" ref={container} key={ticker} onKeyDown={event => {
    if (event.key === 'Escape' && container.current?.open) {
      event.preventDefault(); container.current.open = false; container.current.querySelector('summary')?.focus();
    }
  }}>
    <summary aria-label={`Actions for ${ticker}`} title="Ticker actions"><span aria-hidden="true">•••</span></summary>
    <div className="tc-ticker-actions-panel">
      <button disabled={busy} onClick={() => action(onRefresh)}><span aria-hidden="true">↻</span>{busy ? 'Refreshing…' : 'Refresh company info'}</button>
      <button disabled={busy} className="tc-remove-ticker" onClick={() => action(onRemove)}><span aria-hidden="true">×</span>Remove ticker</button>
    </div>
  </details>;
}
